import { useMemo } from 'react';
import { keyBy } from 'lodash-es';
import { useLocation } from 'react-router';
import { useDevice } from 'seagull';
import { useRootDevice } from '~/providers/DeviceProvider';
import { getHomePagePages } from '~/utils/routeConfigs';
import { useFeatureFlags } from './useFeatureFlags';
export function useIsMobileForHomePage() {
    const { isMobileDevice } = useDevice();
    const { isMobileDevice: isMobileDeviceFromRoot } = useRootDevice();
    const { DASHBOARD_MOBILE = false, AGREEMENTS_DASHBOARD_MOBILE = false, INVOICES_DASHBOARD_MOBILE = false, PROPOSALS_DASHBOARD_MOBILE = false } = useFeatureFlags();
    const location = useLocation();
    const homePagePages = useMemo(()=>keyBy(getHomePagePages({
            DASHBOARD_MOBILE,
            AGREEMENTS_DASHBOARD_MOBILE,
            INVOICES_DASHBOARD_MOBILE,
            PROPOSALS_DASHBOARD_MOBILE
        }), 'url'), [
        DASHBOARD_MOBILE,
        AGREEMENTS_DASHBOARD_MOBILE,
        INVOICES_DASHBOARD_MOBILE,
        PROPOSALS_DASHBOARD_MOBILE
    ]);
    return useMemo(()=>{
        var _homePagePages_location_pathname;
        return isMobileDevice || isMobileDeviceFromRoot && !!((_homePagePages_location_pathname = homePagePages[location.pathname]) === null || _homePagePages_location_pathname === void 0 ? void 0 : _homePagePages_location_pathname.supportsMobileDevice);
    }, [
        isMobileDevice,
        isMobileDeviceFromRoot,
        homePagePages,
        location.pathname
    ]);
}
